// Single source of truth for TopicElement.type - a free string the backend
// explicitly leaves frontend-owned (its own comment on TopicElement: adding
// a new type is "a pure frontend change"), mirroring
// variables/exerciseBlockTypes.js's convention. v1 ships only 2 types since
// the user has said Topic will grow more content later - adding a 3rd type
// later means: one entry here + one entry in topicBlockEditors.jsx's
// TOPIC_BLOCK_EDITOR_REGISTRY, nothing else.

export const TOPIC_BLOCK_TYPES = {
    text: {
        type: 'text', label: 'Текст', accent: '#7ec2e8',
        // uses TopicElement.text directly, config unused
        defaultConfig: {},
    },
    media: {
        type: 'media', label: 'Медіа', accent: '#c77dff',
        // config: {url, caption} - v1 uses a pasted URL, no upload widget
        // (no upload infra exists anywhere in this codebase yet - see
        // topicBlockEditors.jsx). TopicElement.file (the real File FK) is
        // deliberately left unset for now, upgradeable later.
        defaultConfig: { url: '', caption: '' },
    },
    video_embed: {
        type: 'video_embed', label: 'Відео за посиланням', accent: '#a2a2a2',
        // config: {url, description} - a pasted YouTube/Vimeo link, embedded
        // via VideoEmbedPreview.jsx - deliberately separate from `media`'s
        // self-hosted-file video (which plays a raw <video src>, cannot
        // play a page link at all). Accent matches the embed_* family's
        // "this is an embed" grey.
        defaultConfig: { url: '', description: '' },
    },
};

export const TOPIC_BLOCK_TYPE_LIST = Object.values(TOPIC_BLOCK_TYPES);

export function getTopicBlockType(type) {
    return TOPIC_BLOCK_TYPES[type] || null;
}
